import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useContext } from "react";
import { GeaoContext } from "../../../GeaoContextProvider";
import GeaoVerticalStepperLayout from "../Layout/GeaoVerticalStepperLayout";
import useTitle from "../../../../../hooks/useTitle";
import BackgroundQuestions from "./BackgroundQuestions";
import { validationSchema } from "./validation";
import { interviewToFormData } from "./mappers";
import useFormEvents from "./useFormEvents";
import FormButtons from "../FormButtons/FormButtons";

export default function BackgroundInformationForm({
    verticalStepperElements,
    flowType,
    componentName
}) {
    useTitle("Background Information");

    const { agentInterview } = useContext(GeaoContext);

    const useFormReturn = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: interviewToFormData(agentInterview)
    });

    const { handleSubmit, getValues, trigger } = useFormReturn;

    const { onSubmit, onSaveAndExit, saving } = useFormEvents({
        getValues,
        trigger,
        flowType,
        componentName
    });

    return (
        <GeaoVerticalStepperLayout
            verticalStepperElements={verticalStepperElements}
            currentStepperItem={"Background Information"}
            header="Background Information"
        >
            <FormProvider {...useFormReturn}>
                <form className="form geao-form" onSubmit={handleSubmit(onSubmit)}>
                    <BackgroundQuestions />

                    <FormButtons
                        onSaveAndExit={onSaveAndExit}
                        disabled={saving}
                    />
                </form>
            </FormProvider>
        </GeaoVerticalStepperLayout>
    );
}